module.exports = __webpack_public_path__ + "images/emoji/clapper.0e58793eede8ce2318c3.png";